import { IBaseComponent } from '../components/controls/base.component';
import { MenuTabProperty } from '../models/menutab/menutab.property.model';

export const REGISTRY = new Map<string, IBaseComponent>();
export const MENUTABREGISTRY = [];
export const CONTROLGROUPS = [];
export const PROPERTYGROUPS = [];
export const PROPERTYPANELS = [];
export const PROPERTIES: MenuTabProperty[] = [];
export const WIDGETREGISTRY = new Map<string, IBaseComponent>();
export const GLOBALEVENTREGISTRY = [];
export const LAYOUTEVENTREGISTRY = [];
